// eslint-disable-next-line import/prefer-default-export
export const ADD_PERSON_SET_IS_SAVE_DISABLED = 'ADD_PERSON_SET_IS_SAVE_DISABLED';
